let vibe_cake_masters_quiz_reset = function( $ ) {

	let $form,
		$button;

	let _init = function() {
		$form   = $( 'form.quiz-form' );
		$button = $( '#reset-quiz' );

		if ( $form.length > 0 && $button.length > 0 ) {
			_setup_button();
		}
	};

	let _setup_button = function() {
		$button.on( 'click', ( e ) => {
			e.preventDefault();

			$form.find( 'button[type="submit"][name="quiz_reset"]' ).trigger( 'click' );
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_quiz_reset;